import { appendIf } from '@btime/helpers'
import { assoc, compose } from 'ramda'
import { useState } from 'react'

import { useCurrentModal } from '../../../../components/modals/ModalsContext'

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.checklist?.id, { path: ['checklist'], message: 'Campo obrigatório' }),
    ...appendIf(!form.userOrGroup?.id, { path: ['userOrGroup'], message: 'Campo obrigatório' })
  ]

  setErrors(errors)
  return errors.length === 0
}

const cleanRequest = compose(
  item => assoc('user', item.userOrGroup?.__typename === 'User' ? item.userOrGroup : null, item),
  item => assoc('group', item.userOrGroup?.__typename === 'UserGroup' ? item.userOrGroup : null, item)
)

const useHandleSubmit = () => {
  const [loading, setLoading] = useState(false)
  const {
    data: { onSubmit }
  } = useCurrentModal()

  const request = (form, { setErrors }) => {
    const isValid = validate(form, setErrors)
    if (isValid) {
      const data = cleanRequest(form)
      setLoading(true)
      Promise.resolve(onSubmit(data)).finally(() => setLoading(false))
    }
  }
  return [request, loading]
}

export default useHandleSubmit
